module.exports = __webpack_public_path__ + "img/Anu.0a465ddd.jpg";